import React from 'react';
import Academy from './Academy'

const Academies = ({className, academies}) => {
  return (
    <div className={className}>
      {renderAcademies(academies)}
    </div>
  );
};

function renderAcademies(academies) {
  return academies.map(academy =>
    <Academy academy={academy}/>
  );
}

export default Academies;



// WEBPACK FOOTER //
// ./src/views/dashboard/Academies.js